import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { useFormikContext } from "formik";
import useDeviceType from "hooks/useDeviceType";
import DateRangePicker from "library/Molecules/DatePicker/DateRangePicker";
import Filter from "library/Molecules/Filter";
import { isNull } from "lodash";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { retrieveContactTimezone } from "store/features/localization.store";

const DateFilter = () => {
  const { isMobile } = useDeviceType();

  const { setFieldValue } = useFormikContext();

  const timezone = useSelector(retrieveContactTimezone);

  const handleChangeDate = useCallback(
    (_, value) => {
      setFieldValue("start", value[0] ? new Date(value[0]).toISOString() : null);
      setFieldValue("end", value[0] ? new Date(value[1]).toISOString() : null);
    },
    [setFieldValue]
  );

  return (
    <DateRangePicker
      id="list-time-filter"
      name="interval"
      onSelect={handleChangeDate}
      renderInput={({ inputRef, open, value }) => (
        <div ref={inputRef}>
          <Filter.TriggerButton
            id="list-time-filter"
            icon={<CalendarMonthOutlinedIcon fontSize="small" />}
            label={!isMobile && !isNull(value) && <>{value}</>}
            onClick={open}
            invisible={!(isMobile && !isNull(value))}
          />
        </div>
      )}
      timezone={timezone}
    />
  );
};

export default DateFilter;
